import React from 'react'

const Licenseing = () => {
  return (
    <div className='min-h-[80vh] text-white flex justify-center items-center'>
      <img width={70} src="https://img.icons8.com/?size=100&id=E3gXM3CtlGFI&format=png&color=000000" alt="" />
      <h1 className='text-3xl ml-3'> Google Verified This Portfolio Website
      </h1>
    </div>
  )
}

export default Licenseing